import React from 'react'
import Layout from './../../components/help/Layout/Layout'
import Seo from '../../components/help/Seo'
import Header from '../../components/ui/Header/Header'
import Intro from '../../components/ui/Intro/Intro'
import { getHrefToHome } from '../../utils/getHrefToHome'
import { graphql, useStaticQuery } from 'gatsby'
import Finance from '../../components/pages/Finance/Finance'

const TeamPage = () => {
    const lang = 'hy'

    const hrefHome = getHrefToHome(lang)

    const data = useStaticQuery(graphql`
        {
            sectionTitle: datoCmsRenshinPageFinance(title: { eq: "Title" }, locale: { eq: "hy" }) {
                value
            }

            tabs: allDatoCmsRenshinFinanceSection(sort: { fields: sorting, order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    name
                }
            }

            files: allDatoCmsRenshinFinance(filter: { locale: { eq: "hy" } }) {
                nodes {
                    name
                    date
                    description
                    section {
                        name
                    }
                    file {
                        mimeType
                        url
                        size
                    }
                    downloadText
                }
            }

            photo: datoCmsRenshinPageTeam(title: { eq: "Photo" }, locale: { eq: "hy" }) {
                photoDesktop {
                    url
                }
                photoTabletA {
                    url
                }

                photoTabletP {
                    url
                }

                photoMobile {
                    url
                }
            }

            seo: datoCmsRenshinSeo(originalId: { eq: "143518598" }, locale: { eq: "hy" }) {
                titleH1
                crumbsName
                bgDesktop {
                    url
                }
                bgTabletA {
                    url
                }
                bgTabletP {
                    url
                }

                bgMobile {
                    url
                }
                footerLinks {
                    title
                    url
                }
                seo {
                    title
                    description
                }
            }

            main: datoCmsRenshinSeo(originalId: { eq: "114097337" }, locale: { eq: "hy" }) {
                crumbsName
            }
        }
    `)

    const breadCrumbs = [
        { name: `${data.main.crumbsName}`, href: `${hrefHome}`, current: false },
        { name: `${data.seo.crumbsName}`, current: true }
    ]

    const photo = {
        1920: data.seo.bgDesktop.url,
        1440: data.seo.bgDesktop.url,
        1024: data.seo.bgTabletA?.url,
        768: data.seo.bgTabletP?.url,
        360: data.seo.bgMobile?.url
    }

    return (
        <Layout lang={lang}>
            <Seo title={data.seo?.seo?.title} description={data.seo?.seo?.description} />
            <Header light lang={lang} />
            <Intro crumbs={breadCrumbs} title={data.seo.titleH1} photo={photo} lang={lang} />
            <Finance data={data} lang={lang} />
        </Layout>
    )
}

export default TeamPage
